export class WeekViewUserModeProjectDetailsModel {
    constructor() {
        this.projectDisplayString = "";
        this.projectCode = 0;
        this.projectName = "";
        this.userProjectTime = [];
    }
}
export default class WeekViewUserModeProjectDetails extends WeekViewUserModeProjectDetailsModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
